<template>
	<PageContainer title="Dashboard">
		<InfoWidgets />

		<div class="row-container">
			<AulasInfo />

			<RankInstrutores />
		</div>

		<NotificationsSection />

		<AulasPorVeiculo />
	</PageContainer>
</template>

<script>
import PageContainer from '../core/PageContainer.vue'
import InfoWidgets from './InfoWidgets.vue'
import AulasPorVeiculo from './AulasPorVeiculo.vue'
import router from '@/router'
import RankInstrutores from './RankInstrutores.vue'
import AulasInfo from './AulasInfo.vue'
import NotificationsSection from './NotificationsSection.vue'

export default {
	name: 'dashboard',
	components: {
		AulasPorVeiculo,
		PageContainer,
		InfoWidgets,
		RankInstrutores,
		AulasInfo,
		NotificationsSection,
	},
	data() {
		return {
			showModalBloqueio: false,
			modalInformativo: {
				conteudo: {
					data_hoje: '',
					data_limite: '',
					count_faturas: 0
				}
			},
			faturas: [],
			now: '',
		}
	},
	created() {
		if (localStorage.id_role === '2') {
			router.push({ name: 'DashboardMonitoramento' })
		} else if (localStorage.id_role === '4') {
			router.push({ name: 'aluno' })
		}

		// GET DATA DE HOJE
		var today = new Date()
		var dd = String(today.getDate()).padStart(2, '0')
		var mm = String(today.getMonth() + 1).padStart(2, '0')
		var yyyy = today.getFullYear()
		today = dd + '/' + mm + '/' + yyyy
		this.now = today
	},
	mounted() {
		if (localStorage.id_role === '3') {
			router.push({ name: 'aulasInstrutor' })
		}
	},
}
</script>

<style lang="scss" scoped>
.row-container {
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;

	div:first-child {
		flex: 1;
	}

	div:nth-child(2) {
		max-width: 24%;

		@media only screen and (max-width: 780px) {
			max-width: none;
			flex: 1;
		}
	}
}
</style>
